// CoreValues.jsx
import React, { useContext } from "react";
import { GlobalContext } from "../GlobalContext";

export default function CoreValues() {
  const { content } = useContext(GlobalContext);
  const coreValues = content?.core_values;

  if (!coreValues) return null;

  // 🧩 تحويل النص إلى JSON (الكروت)
  const cards = (() => {
    try {
      return JSON.parse(coreValues.cards || "[]");
    } catch {
      return [];
    }
  })();

  // 🌐 رابط الصورة الأساسي
  const BASE_URL = "http://localhost/my_projects/my_app";
  const fullCoreValuesImg = coreValues?.image
    ? `${BASE_URL}${coreValues.image}`
    : "/uploads/core-values-default.jpg"; // صورة افتراضية عند غياب الصورة

  return (
    <section className="values-core-section">
      <div className="values-core__content">
        <h2 className="values-core__title">
          <i className="fa-solid fa-heart"></i> {coreValues.title}
        </h2>

        <p>{coreValues.description}</p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "132px",
          }}
        >
          {/* 📝 النصوص على اليمين */}
          <div style={{ flex: 1 }}>
            <div className="values-core__items">
              {cards.map((item, index) => (
                <div className="value-card" key={index}>
                  <i className={item.icon}></i>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 🖼️ الصورة على الشمال */}
          <div style={{ flex: "0 0 380px" }}>
            <img
              src={fullCoreValuesImg}
              alt="core values"
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "16px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                objectFit: "cover",
                opacity: coreValues?.image ? 1 : 0.85, // خفف الافتراضية شوي
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
